import React, { createContext, ReactChild } from "react";
import { PluginData } from "./PluginRegistryTypes";

export interface PluginDataContextType {
  pluginData: PluginData;
}

export const PluginDataContext = createContext<PluginDataContextType>({
  pluginData: {
    contentful: {},
  },
});

export interface PluginDataContextProviderProps {
  pluginData: PluginData;
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const PluginDataContextProvider = (props: PluginDataContextProviderProps) => {
  const { pluginData, children } = props;

  return <PluginDataContext.Provider value={{ pluginData }}>{children}</PluginDataContext.Provider>;
};
